import React, { useEffect, useState } from 'react';
const INITIAL_SECONDS = 48 * 60 * 60;
function formatTime(totalSeconds: number) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map(value => value.toString().padStart(2, '0')).join(':');
}
export function UrgencyBar() {
  const [secondsLeft, setSecondsLeft] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft(current => Math.max(0, current - 1));
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const countdown = formatTime(secondsLeft);
  return <div className="sticky top-0 z-50 bg-brand-green px-3 py-2 text-center text-white shadow-sm" data-id="element-215">
      <p className="hidden text-sm font-medium md:block" data-id="element-216">
        ⏳ Offerta di lancio: kit completo (valore € 146) a solo{' '}
        <strong data-id="element-217">€ 19</strong> — termina tra:{' '}
        <strong className="tabular-nums" data-id="element-218">{countdown}</strong>
      </p>
      <p className="text-xs font-medium md:hidden" data-id="element-219">
        ⏳ Offerta di lancio: <strong data-id="element-220">€ 19</strong> ·{' '}
        <strong className="tabular-nums" data-id="element-221">{countdown}</strong>
      </p>
    </div>;
}